import { Route, Routes } from "react-router-dom";

import TransactionsPage from "./TransactionsPage";

export const LIVE_LEDGER_ROUTE = "live-ledger";

type LiveLedgerRoutesProps = {
  /** Institution's configured support reply time, parsed from the page in `main.tsx`. */
  replyTime: string;
};

const LiveLedgerRoutes = ({ replyTime }: LiveLedgerRoutesProps) => (
  <Routes>
    <Route index element={<TransactionsPage replyTime={replyTime} />} />
  </Routes>
);

export default LiveLedgerRoutes;
